import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/image/png/DronePlanet_Logo-removebg.png";
import logo1 from "../assets/image/png/newlogo.png";
import MobileDrawer from "./MobileDrawer";
import {
  ChevronDown,
  Cloud,
  FileText,
  Key,
  Mail,
  Menu,
  Package,
  Phone,
  Settings,
  ShoppingCart,
  User,
  Rocket,
  Wrench,
  Cpu,
  GraduationCap,
  Building2,
  Sparkles,
  Radar,
  ArrowRight,
} from "lucide-react";
import Container from "./Container";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleLoginPopup } from "../redux/slice/userSlice";
import LoginModal from "../components/auth/LoginModal";
import Cookies from "js-cookie";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showAccount, setShowAccount] = useState(false);
  const [showSignInModal, setShowSignInModal] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [hoveredItem, setHoveredItem] = useState({ menu: null, sub: null });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showLogin } = useSelector((state) => state.user);
  const userName = Cookies.get("user");

  const getFirstName = (fullName) => {
    return fullName ? fullName.split(" ")[0] : "";
  };

  const firstName = getFirstName(userName);
  const handleProtectedRoute = (path) => {
    const user = Cookies.get("user");

    if (!user) {
      dispatch(handleLoginPopup(true)); // open modal
      setShowAccount(false); // close dropdown
    } else {
      navigate(path); // go to page
      setShowAccount(false);
    }
  };

  const navItems = [
    { name: "Home", path: "/" },
    // { name: "DSK", path: "/dsk" },
    // { name: "Drone City ", path: "/drone-city" },
    {
      name: "Marketplace",
      dropdown: [
        {
          name: "Buy Drone",
          path: "/product/all-drone",
          description: "Explore ready-to-fly drones for every mission",
          icon: Rocket,
        },
        {
          name: "Buy Drone Parts",
          path: "/drone-parts",
          description: "Genuine spares, batteries & upgrade kits",
          icon: Wrench,
        },
        {
          name: "SaaS",
          path: "/intellegence-market-solutions",
          description: "Intelligence & automation software solutions",
          icon: Cpu,
        },
      ],
    },
    {
      name: "Training",
      dropdown: [
        {
          name: "Drone Training Courses",
          path: "/training-courses/0",
          description: "Certified pilot programs, beginner to pro",
          icon: GraduationCap,
        },
        {
          name: "Drone Training Institutes",
          path: "/training-courses/1",
          description: "Find accredited institutes near you",
          icon: Building2,
        },
        {
          name: "Deeptech Workshops",
          path: "/training-courses/2",
          description: "Hands-on sessions on emerging drone tech",
          icon: Sparkles,
        },
      ],
    },
    {
      name: "Services",
      dropdown: [
        {
          name: "DaaS",
          path: "/daas-service-page",
          description: "Drone-as-a-Service for enterprise operations",
          icon: Cloud,
        },
        {
          name: "TaaS",
          path: "/taas",
          description: "Training-as-a-Service, on demand & scalable",
          icon: Radar,
        },
      ],
    },
    { name: "Careers", path: "/jobs-hire-page" },
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".account-dropdown")) {
        setShowAccount(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    if (showLogin) {
      setShowSignInModal(true);
    }
  }, [showLogin]);

  return (
    <header className=" w-full shadow-sm">
      {/* Top Bar */}
      {/* <div className="bg-[#003580] text-white text-sm py-2">
        <Container>
          <div className="flex justify-between items-center">
            <div className="flex gap-6">
              <span className="flex items-center gap-2">
                <Phone size={16} />
                +91 93114 62002
              </span>

              <span className="flex items-center gap-2">
                <Mail size={16} />
                support@droneplanet.in
              </span>
            </div>
          </div>
        </Container>
      </div> */}

      {/*  Middle Header */}
      <div className="bg-white border-b">
        <Container>
          <div className="flex items-center justify-between relative w-full min-h-[40px] md:min-h-[64px]">
            {/* LEFT → Drone Tech Logo (Hidden on Mobile)   */}
            {/* Removed Drone Tech logo as requested */}

            {/* CENTER → Drone Planet (Left on Mobile, Centered on Desktop) */}
            <div className="flex flex-col items-start md:items-center justify-center mr-auto md:absolute md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 z-10">
              <Link to="/" className="flex items-center">
                <img
                  src={logo}
                  alt="drone planet logo"
                  className="h-8 md:h-10 w-auto object-contain md:mt-3"
                />
              </Link>

              {/* Tagline */}
              <p className="hidden md:block text-[11px] text-gray-500 mt-0.5 whitespace-nowrap text-center">
                A Brand by Drone Tech Multi State Cooperative Society
              </p>
            </div>
            {/* RIGHT → Actions (Login, Cart, Menu)         */}
            <div className="flex items-center gap-2 md:gap-4 shrink-0 ml-auto z-20 relative bg-white md:bg-transparent pl-2 md:pl-0">
              <div className="relative account-dropdown">
                <button
                  aria-expanded={showAccount}
                  aria-haspopup="true"
                  onClick={() => setShowAccount(!showAccount)}
                  className="hidden md:inline-flex items-center gap-1.5 bg-[#003580] text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-800 transition border-none"
                >
                  <span>{userName ? firstName : "Login"}</span>
                  <ChevronDown
                    size={16}
                    className={`transition-transform duration-200 ${showAccount ? "rotate-180" : ""}`}
                  />
                </button>

                {showAccount && (
                  <div className="absolute right-0 top-full mt-2 w-[340px] bg-white shadow-xl rounded-md border border-gray-100 z-50 p-4">
                    <div className="grid grid-cols-2 gap-6">
                      {/* LEFT COLUMN */}
                      <div>
                        <h4 className="text-[15px] font-bold text-[#003580] mb-3 uppercase tracking-wide">
                          Your Account
                        </h4>
                        <div className="space-y-3 text-sm font-medium">
                          {!userName ? (
                            <>
                              <button
                                onClick={() => {
                                  setShowAccount(false);
                                  dispatch(handleLoginPopup(true));
                                }}
                                className="flex items-center gap-2 text-gray-700 hover:text-[#003580] border-none outline-none bg-transparent shadow-none"
                              >
                                <User size={16} /> Log In / Sign Up
                              </button>

                              <button
                                onClick={() => handleProtectedRoute("/orders")}
                                className="flex items-center gap-2 text-gray-700 hover:text-[#003580] border-none outline-none bg-transparent shadow-none"
                              >
                                <Package size={16} /> Your Orders
                              </button>

                              <button
                                onClick={() => handleProtectedRoute("/account")}
                                className="flex items-center gap-2 text-gray-700 hover:text-[#003580] border-none outline-none bg-transparent shadow-none"
                              >
                                <User size={16} /> Your Account
                              </button>
                            </>
                          ) : (
                            <>
                              <Link
                                to="/account"
                                className="flex items-center gap-2 text-gray-700 hover:text-[#003580]"
                              >
                                <User size={16} /> Your Account
                              </Link>

                              <Link
                                to="/orders"
                                className="flex items-center gap-2 text-gray-700 hover:text-[#003580]"
                              >
                                <Package size={16} /> Your Orders
                              </Link>

                              <button
                                onClick={() => {
                                  Cookies.remove("user");
                                  Cookies.remove("token");
                                  Cookies.remove("userId");
                                  window.location.reload();
                                }}
                                className="flex items-center gap-2 text-red-600 hover:text-red-700 border-none outline-none bg-transparent shadow-none"
                              >
                                Logout
                              </button>
                            </>
                          )}
                        </div>
                      </div>

                      {/* RIGHT COLUMN */}
                      <div>
                        <h4 className="text-[15px] font-bold text-[#003580] mb-3 uppercase tracking-wide">
                          Partners
                        </h4>
                        <div className="space-y-3 text-sm font-medium">
                          <Link
                            to="/vendor-onboarding"
                            className="flex items-center gap-2 text-gray-700 hover:text-[#003580] transition-colors"
                          >
                            <FileText size={16} /> Vendor Forms
                          </Link>
                          <Link
                            to="/aboutdaas"
                            className="flex items-center gap-2 text-gray-700 hover:text-[#003580] transition-colors"
                          >
                            <Cloud size={16} /> DaasConnect
                          </Link>
                          <Link
                            to="/DroneXplore"
                            className="flex items-center gap-2 text-gray-700 hover:text-[#003580] transition-colors"
                          >
                            <Settings size={16} /> DroneXplore
                          </Link>
                          <hr className="my-3 border-gray-100" />
                          <Link
                            to="https://app.droneplanet.in/auth"
                            className="flex items-center gap-2 text-[#003580] font-bold hover:text-blue-900 transition-colors"
                            target="_blank"
                          >
                            <Key size={16} /> Partner Login
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <Link
                to="/cart"
                className="relative p-2 hover:bg-gray-100 rounded-full transition-colors"
              >
                <ShoppingCart size={22} className="text-[#003580]" />
              </Link>

              <button
                onClick={() => setIsOpen(true)}
                className="md:hidden p-2 rounded-md hover:bg-gray-100 active:scale-95 transition-all duration-150"
              >
                <Menu size={24} className="text-[#003580]" />
              </button>
            </div>
          </div>
        </Container>
      </div>

      {/* 🔽 Navbar */}
      <div className="hidden md:block bg-[#003580] text-white py-2">
        <Container>
          <nav className="hidden md:flex justify-between gap-8">
            {navItems.map((item, index) => (
              <div
                key={index}
                className="relative group"
                onMouseEnter={() => item.dropdown && setActiveMenu(index)}
                onMouseLeave={() => item.dropdown && setActiveMenu(null)}
              >
                {/* Nav Item */}
                {item.dropdown ? (
                  <div className="relative flex items-center gap-1 cursor-pointer py-1 select-none">
                    <span className="relative">
                      {item.name}
                      <span
                        className={`absolute -bottom-1 left-0 h-[2px] bg-white rounded-full transition-all duration-300 ease-out ${
                          activeMenu === index ? "w-full" : "w-0"
                        }`}
                      />
                    </span>
                    <ChevronDown
                      size={14}
                      className={`transition-transform duration-300 ${
                        activeMenu === index ? "rotate-180" : ""
                      }`}
                    />
                  </div>
                ) : (
                  <Link to={item.path} className="relative text-white py-1 inline-block">
                    {item.name}
                    <span className="absolute -bottom-1 left-0 h-[2px] w-0 bg-white rounded-full transition-all duration-300 ease-out group-hover:w-full" />
                  </Link>
                )}

                {/* Dropdown */}
                {item.dropdown && (
                  <div
                    className={`absolute left-1/2 -translate-x-1/2 top-full pt-3 min-w-[240px] w-max z-50 transition-all duration-300 ease-out ${
                      activeMenu === index
                        ? "opacity-100 visible translate-y-0"
                        : "opacity-0 invisible -translate-y-2 pointer-events-none"
                    }`}
                  >
                    {/* Little pointer arrow */}
                    <div className="absolute left-1/2 -translate-x-1/2 top-2 w-2.5 h-2.5 bg-white rotate-45 shadow-sm border-t border-l border-gray-100" />

                    <div className="relative bg-white text-black rounded-xl shadow-2xl border border-gray-100 overflow-hidden">
                      {/* Accent top bar */}
                      <div className="h-1 w-full bg-gradient-to-r from-[#003580] via-blue-500 to-cyan-400" />

                      <div className="p-1.5">
                        {item.dropdown.map((subItem, subIndex) => {
                          const Icon = subItem.icon;
                          const isItemHovered =
                            hoveredItem.menu === index &&
                            hoveredItem.sub === subIndex;
                          const isVisible = activeMenu === index;
                          return (
                            <Link
                              key={subIndex}
                              to={subItem.path}
                              onMouseEnter={() =>
                                setHoveredItem({ menu: index, sub: subIndex })
                              }
                              onMouseLeave={() =>
                                setHoveredItem({ menu: null, sub: null })
                              }
                              className={`flex items-start gap-2 rounded-lg px-2.5 py-2 transition-all duration-200 ease-out ${
                                isItemHovered ? "bg-blue-50" : "bg-white"
                              } ${
                                isVisible
                                  ? "opacity-100 translate-x-0"
                                  : "opacity-0 -translate-x-1"
                              }`}
                              style={{
                                transitionProperty:
                                  "background-color, opacity, transform",
                                transitionDelay: isVisible
                                  ? `${subIndex * 60}ms`
                                  : "0ms",
                              }}
                            >
                              {Icon && (
                                <span
                                  className={`flex items-center justify-center w-7 h-7 rounded-md shrink-0 transition-all duration-200 ease-out ${
                                    isItemHovered
                                      ? "bg-[#003580] text-white scale-110"
                                      : "bg-blue-50 text-[#003580]"
                                  }`}
                                >
                                  <Icon size={14} />
                                </span>
                              )}
                              <span className="flex-1 min-w-0">
                                <span
                                  className={`flex items-center gap-1 text-[13px] font-semibold transition-colors duration-200 ${
                                    isItemHovered
                                      ? "text-[#003580]"
                                      : "text-gray-900"
                                  }`}
                                >
                                  {subItem.name}
                                  <ArrowRight
                                    size={12}
                                    className={`text-[#003580] transition-all duration-200 ease-out ${
                                      isItemHovered
                                        ? "opacity-100 translate-x-0"
                                        : "opacity-0 -translate-x-1"
                                    }`}
                                  />
                                </span>
                                {subItem.description && (
                                  <span className="block text-[11px] text-gray-500 mt-0.5 leading-snug">
                                    {subItem.description}
                                  </span>
                                )}
                              </span>
                            </Link>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </nav>
        </Container>
      </div>

      {/* 📱 Mobile Menu */}
      <MobileDrawer isOpen={isOpen} setIsOpen={setIsOpen} navItems={navItems} />

      <LoginModal
        open={showSignInModal}
        onClose={() => {
          setShowSignInModal(false);
          dispatch(handleLoginPopup(false));
        }}
      />
    </header>
  );
};

export default Header;